import { RouteRecordRaw } from 'vue-router';
import { databeheerder, systeembeheerder } from '@/core/security/roleTypes';
import DeliveryCreate from './DeliveryCreate.vue';
import DeliveryDetail from './DeliveryDetail.vue';
import DeliveryList from './DeliveryList.vue';

export const deliveryRoutes: RouteRecordRaw = {
    path: '/delivery',
    name: 'delivery',
    redirect: '/delivery/list',
    meta: {
        hasRoles: [databeheerder, systeembeheerder],
    },
    children: [
        {
            path: '/delivery/list',
            name: 'delivery.list',
            component: DeliveryList,
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
        },
        {
            path: 'create',
            name: 'delivery.create',
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
            component: DeliveryCreate,
        },
        {
            path: '/delivery/:id',
            name: 'delivery.detail',
            component: DeliveryDetail,
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
        },
    ],
};
